import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import axios from 'axios';
import { Download } from 'lucide-react';
import { downloadPdf } from '../../utils/downloadPdf';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PortalInvoices() {
  const { t } = useLanguage();
  const [invoices, setInvoices] = useState<any[]>([]);

  useEffect(() => {
    axios.get(`${API}/api/invoices`, { withCredentials: true }).then(r => setInvoices(r.data)).catch(() => {});
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar type="portal" active="invoices" />
      <main data-testid="portal-invoices-page" style={{ flex: 1, background: 'var(--bg-portal)', padding: 32 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto' }}>
          <h1 style={{ fontFamily: 'var(--font-heading)', fontSize: 28, fontWeight: 700, marginBottom: 24 }}>{t('portal.invoices')}</h1>
          <div style={{ background: 'white', border: '1px solid var(--border)' }}>
            {invoices.length === 0 ? (
              <div style={{ padding: 48, textAlign: 'center', color: 'var(--text-muted)' }}>{t('portal.no_invoices')}</div>
            ) : (
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom: '1px solid var(--border)' }}>
                      {['#', t('portal.amount'), t('portal.status'), t('portal.date'), 'PDF'].map(h => (
                        <th key={h} style={{ padding: '12px 20px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {invoices.map((inv: any, i: number) => (
                      <tr key={inv._id} style={{ borderBottom: '1px solid var(--border)' }}>
                        <td style={{ padding: '14px 20px', fontSize: 14, fontFamily: 'var(--font-mono)' }}>INV-{String(i + 1).padStart(4, '0')}</td>
                        <td style={{ padding: '14px 20px', fontSize: 14, fontWeight: 600 }}>{inv.currency} {inv.total?.toFixed(2)}</td>
                        <td style={{ padding: '14px 20px' }}>
                          <span style={{ padding: '4px 10px', fontSize: 12, fontWeight: 600, background: inv.status === 'paid' ? 'rgba(34,197,94,0.12)' : 'rgba(251,191,36,0.12)', color: inv.status === 'paid' ? '#16A34A' : '#D97706', textTransform: 'uppercase' }}>
                            {t(`status.${inv.status}`)}
                          </span>
                        </td>
                        <td style={{ padding: '14px 20px', fontSize: 13, color: 'var(--text-muted)' }}>{inv.issue_date ? new Date(inv.issue_date).toLocaleDateString() : '-'}</td>
                        <td style={{ padding: '14px 20px' }}>
                          <button onClick={() => downloadPdf(`/api/invoices/${inv._id}/pdf`, `invoice-${inv._id.slice(-8)}.pdf`)} data-testid={`download-pdf-${inv._id}`}
                            style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', fontSize: 11, fontWeight: 600, background: 'rgba(13,71,161,0.08)', color: 'var(--primary)', border: '1px solid rgba(13,71,161,0.2)', cursor: 'pointer' }}>
                            <Download size={12} /> PDF
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
